// Module
var code = "<div class=\"add-note-launcher\" ng-if=\"vm.displayNoteLauncher\"> <button class=\"btn btn-azure btn-xs\" ng-click=\"vm.newNote()\"> <icon-notebook-alt></icon-notebook-alt> New Note </button> </div> ";
// Exports
module.exports = code;